import { render, staticRenderFns } from "./TelephonyTab.vue?vue&type=template&id=38a20a13&scoped=true"
import script from "./TelephonyTab.vue?vue&type=script&lang=js"
export * from "./TelephonyTab.vue?vue&type=script&lang=js"
import style0 from "./TelephonyTab.vue?vue&type=style&index=0&id=38a20a13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a20a13",
  null
  
)

export default component.exports